import { render, staticRenderFns } from "./ContractValueClusters.vue?vue&type=template&id=05f97cd8&"
import script from "./ContractValueClusters.vue?vue&type=script&lang=js&"
export * from "./ContractValueClusters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports